import React, { useRef } from "react";
import Typed from "react-typed";
import "./FName.css";
import fWD from "../assets/fWD.svg";
import oe from "../assets/oe.svg";
import dwd from "../assets/dwd.svg";

// import { gsap } from "gsap/gsap-core";
import { gsap } from "gsap/all";

export const FName = ({fullpageApi}) => {
  let divIm = useRef(null);
  var tl = gsap.timeline();
  gsap.to(".nm", { duration: 2, x: 100, opacity: 1 });
  gsap.to(".dwd", { duration: 2, y: 50, opacity: 1 }).delay(0.8);

  return (
    <div id="home" className="bg" ref={(el) => (divIm = el)}>
      <div className="fn-wrapper">
        <div className="nm">Hey!👋 My name is <span className="name">Oussama</span>!</div>

        <div className="occ">
          <Typed strings={["Full-stack Web developer. Loves working remotely, always growing! Completed my training at Microverse."]} typeSpeed={20} />
          
        </div>
        <img className="dwd" src={dwd} alt="Scroll Down" />
      </div>
    </div>
  );
};
